import * as React from 'react';
import { HeroBannerSingleCTA, HeroBannerSingleCTAKind } from './HeroBannerSingleCTA';
import { transformDYTemplateVariables } from './utils';
import { DYHeroBannerSingleCTAProps } from './DYHeroBannerSingleCTA';

export const DYHeroBannerSingleCTAGrid: React.FC<DYHeroBannerSingleCTAProps> = ({ data, onClick }) => {
  if (!data) {
    return <></>;
  }

  const props = transformDYTemplateVariables(data, HeroBannerSingleCTAKind.InGrid);
  return <HeroBannerSingleCTA {...props} onClick={onClick} />;
};
